import { cn } from '@/lib/utils'

import { CaseActivityHistoryItem } from './case-activity-history-item'
import { Loading } from './loading'
import { useCaseActivityHistory } from './use-case-activity-history'

export const CaseActivityHistory = () => {
  const { caseAddDeleteHistoryData, isLoadingData } = useCaseActivityHistory()

  if (isLoadingData) {
    return <Loading />
  }

  if (caseAddDeleteHistoryData.length === 0) {
    return <p className={cn('text-center text-gray-500', 'py-3')}>No data yet.</p>
  }

  return (
    <div>
      <ul>
        {caseAddDeleteHistoryData.map((historyData) => (
          <li key={historyData.id} className={cn('border-b border-border last-of-type:border-none')}>
            <CaseActivityHistoryItem data={historyData} />
          </li>
        ))}
      </ul>
    </div>
  )
}
